import { ready } from '@front/utils/wrappers';
import AlpineInstance from 'alpinejs';
function createApp(components, plugins = [], prefix = 'x-', scopeName = 'App') {
    AlpineInstance.prefix(prefix);
    plugins.forEach(AlpineInstance.plugin);
    Object.assign(window, {
        [scopeName]: {
            vm: AlpineInstance,
            ...components,
        },
    });
    ready(AlpineInstance.start);
}
function createPlugin(cb) {
    return cb;
}
function createComponent(cb, scopeName = 'App') {
    return (opts) => cb(opts ?? {}, window[scopeName]);
}
function getRef(ctx, ref) {
    return ctx.$refs[ref];
}
export { getRef, createApp, createComponent, createPlugin };
